import { peopleRef, membershipsRef, slackMembershipsRef, vehiclesRef } from "@/vue-service-database";
import { setSelectedPersonSkillsRating } from "./vue-service-skills";
import { setSelectedMember } from "@/vue-service-groups";
import store from "@/store/";

// Get the user's key from peopleRef, 
function personKeyPromise(user) {
	return peopleRef
		.orderByChild("email")
		.equalTo(user.email)
		.once("value", peopleData => {
			peopleData.forEach(snapshot => {
				return snapshot.key;
			});
		});
}
// Get person's key from their email
function getPersonsPushId(email) {
	const key = Object.keys(store.getters.people).filter(key => store.getters.people[key].email == email);
	return key.toString();
}
function setUserAsSelectedPerson(user) {
	return personKeyPromise(user)
		.then(userKeyData => {
			const userKeyObject = Object.keys(userKeyData.val());
			const userKey = userKeyObject[0];
			// Bad Side Effect ??
			setSelected(userKey);
		});
}
function setSelectedPerson(key) {
	return peopleRef
		.child(key)
		.once("value")
		.then(snapshot => {
			const person = snapshot.val();
			store.dispatch("SET_SELECTED_PERSON_KEY", key);
			store.dispatch("SET_PERSON", person);
			store.dispatch("SET_SELECTED_PERSON_IS_USER", key);
		});
}
function setSelectedSlackMember(key) {
	slackMembershipsRef
		.child(key)
		.once("value")
		.then(snapshot => {
			const slackMembershipData = snapshot.val();
			if (slackMembershipData.memberships) {
				const slackMemberships = slackMembershipData.memberships;
				const slackMembershipNames = slackMemberships
					.map(selectedSlackMember => { return {title: selectedSlackMember.name};});
				// store.dispatch("SET_SELECTED_SLACK_MEMBER", slackMembershipData.email);
				store.dispatch("SET_SELECTED_SLACK_MEMBERSHIPS", slackMemberships);
			}
			// store.dispatch("SET_SELECTED_MEMBER_KEY", key);
		});
}
function setSelectedVehicles(key) {
	return vehiclesRef.once("value")
		.then(snapshot => {
			const vehiclesData = snapshot.val();
			let selectedPersonVehicles = {};
			for (let vehicle in vehiclesData) {
				if (vehiclesData[vehicle].userKey == key) {
					selectedPersonVehicles[vehicle] = vehiclesData[vehicle];
				}
			}
			if (selectedPersonVehicles) {
				store.dispatch("SET_SELECTED_PERSON_VEHICLES", selectedPersonVehicles);
			}
		});
}
/*
 * Updates who the selected person is
 * in the store (globally)
 * 
 * the key is a person's push ID
 */
function setSelected(key) {
	setSelectedPerson(key);
	// TODO - If there are no memberships (such as after creating a new person) selectedMember will be incorrect
	setSelectedMember(key);
	setSelectedVehicles(key);
	setSelectedPersonSkillsRating(key);
}

export {
	getPersonsPushId,
	setUserAsSelectedPerson,
	setSelected,
	setSelectedMember,
	setSelectedSlackMember
};



// WEBPACK FOOTER //
// ./src/vue-service-selected_person.js